const people = [
  {
    id: 1,
    image: "../../img/user-1.png",
    name: "Dr Dayo Ojedokun",
    title: "Vetenary doctor",
    quote:
      "I have been reading your book from day one and i have loved every single day of awesomeness it has delivered.You deserve all the success coming your way.",
  },
  {
    id: 2,
    image: "../../img/user-2.png",
    name: "Kenneth Ahamefula",
    title: "Affiliate Marketer",
    quote:
      "still can’t believe this is a free copywriting masterclass. Once again you nailed it. If you aren’t married yet, I would have given you my sister for free.",
  },
  {
    id: 3,
    image: "../../img/user-3.png",
    name: "Adekunle Abdullateef",
    title: "Digital Marketer",
    quote:
      "Thank you boss, i’ve been looking forward to another masterclass of yours because your whatsapp group was a life changing experience for me all through the covid-19 lockdown.",
  },
];

export default people;
